import styled from 'styled-components';

export const ActivityWrapper = styled.div`
  display: flex;
  margin-top: 30px;

  &:first-child {
    margin-top: 0;
  }
`;

export const ActivityText = styled.div``;

export const ActivityDate = styled.div.attrs({ className: 'caption_text' })`
  margin-top: 5px;
`;
export const ActivityBody = styled.div`
  margin-left: 15px;
`;
